module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_13.51d4d599.mp3";